jQuery(document).ready(function ($) {
  //######################################################//
  //###*****   HP Video Handling  *****#######//
  //######################################################//
  var fade_in_videos = document.querySelectorAll('.fade-in-video');
  var i;
  for (i = 0; i < fade_in_videos.length; i++) {
    fade_in_videos[i].addEventListener(
      'playing',
      function () {
        this.className += ' is-playing';
      },
      { once: true }
    );
  }
  // var iOShome = /iPad|iPhone|iPod/.test(navigator.platform);
  // if (iOShome) {
  //   var background_videos_home = document.querySelectorAll(
  //     ".m-hp-hero-carousel__video-bg video"
  //   );
  //   for (i = 0; i < background_videos_home.length; i++) {
  //     background_videos_home[i].parentNode.removeChild(
  //       background_videos_home[i]
  //     );
  //   }
  // }
  // var iOS = /iPad|iPhone|iPod/.test(navigator.platform);
  // if (iOS) {
  //   var background_videos = document.querySelectorAll(
  //     ".m-hp-hero-carousel__video-bg"
  //   );
  //   var background_video_fallback =
  //     document.querySelectorAll(".video-fallback");

  //   $(".m-hp-hero-carousel__video-bg").remove();
  //   $(".video-fallback").addClass("video-ios");
  // }
});
